import { DateTime } from "luxon";
import { useEffect, useState } from "react";
import { Card, FormCheck } from "react-bootstrap";
import { Trans, useTranslation } from "react-i18next";
import { reminderRead, remindersGet } from "../../api";
import { IconSchedule, TemplateProfileImage } from "../../common/icons";
import { LoadingContainer } from "../../common/loaders/loadingcontainer";
import { jsError, localized } from "../../common/utils";
import { Link } from "react-router";

let loading = false; // load only once per component lifetime
let unit = "days";

const idRe = /\d+$/;

const readReminder = ({ target }) => {
  reminderRead(Number(target.id.match(idRe)), target.checked);
};

export function Reminders() {
  const { t } = useTranslation();

  const { resolvedLanguage } = localized;
  const rtf = new Intl.RelativeTimeFormat(resolvedLanguage);

  const [data, setData] = useState();

  useEffect(() => {
    async function getData() {
      loading = true;
      try {
        const res = await remindersGet();
        res.data.sort((a, b) => new Date(a.taskDetails.expirationDate) - new Date(b.taskDetails.expirationDate));
        setData(res.data);
      } catch (err) {
        jsError(err);
      }
      loading = false;
    }

    if (!loading) {
      getData();
    }
  }, []);

  const subject = (notif, days) => {
    if (notif.relationType === "COMPETENCE_COURSE" && notif.metaData) {
      return `${notif.metaData.certificationName ? notif.metaData.certificationName : t("Course", "Kurssi")} ${days < 0 ? t("validityExpired", "voimassaolo umpeutui") : t("validityExpires", "voimassaolo umpeutuu")}`;
    }

    if (notif.subType === "CONTRACT_PROBATION_EXPIRES") {
      const { contractIdentifier } = notif.metaData;
      const end = days < 0 ? t("ended2", "päättyi") : t("ends", "päättyy");
      // https://react.i18next.com/latest/trans-component
      return <Trans i18nKey="contractProbation">
        työsopimuksen <Link to={`/mgmt/contracts/${contractIdentifier}`}>{{contractIdentifier}}</Link> koeaika {{end}}
      </Trans>;
    }

    if (notif.subType === "CONTRACT_EXPIRES") {
      const { contractIdentifier } = notif.metaData;
      const end = days < 0 ? t("ended2", "päättyi") : t("ends", "päättyy");
      return <Trans i18nKey="fixedContract">
      määräaikainen työsopimus <Link to={`/mgmt/contracts/${contractIdentifier}`}>{{contractIdentifier}}</Link> {{end}}
      </Trans>;
    }

    if (notif.relationType === "DISCUSSION") {
      return t("discussionDeadline", "keskustelun määräaika");
    }

    return notif.subType || notif.relationType;
  };

  return data
    ? <>
      <h4 style={{color: "var(--heeros-blue)"}}>{t("Reminders", "Muistutukset")}</h4>
      <div className="reminders" style={{ maxHeight: "500px", overflowY: "auto", overflowX: "hidden" }}>
        {data.length
          ? data.map(r => {
            const date = new Date(r.taskDetails.expirationDate);
            const diff = DateTime.fromJSDate(date).diff(DateTime.now(), ["years", "months", "weeks", "days"]);
            const days = Math.ceil(diff.days);
            let expires;
            if (diff.years) {
              expires = rtf.format(diff.years, "years");
            } else if (diff.months) {
              expires = rtf.format(diff.months, "months");
            } else if (diff.weeks) {
              expires = rtf.format(diff.weeks, "weeks");
            } else {
              expires = days === 0 ? t("today", "tänään") : rtf.format(days, unit);
            }
            return (
              <Card key={r.notificationId}>
                <Card.Body>
                  <div className="profile-image"><TemplateProfileImage /></div>
                  <FormCheck label={t("Ready", "Tehty")} id={`reminder-${r.notificationId}`} onChange={readReminder} />
                  <span className="person">{r.metaData.personName}</span> {subject(r, days)} {expires}.
                  <br /><IconSchedule /> {date.toLocaleDateString(resolvedLanguage)}
                </Card.Body>
              </Card>
            );
          })
          : <span className="opacity-50">({t("NoReminders", "Ei muistutuksia")})</span>
        }
      </div>
    </>
    : <LoadingContainer />;
}
